import React, { Component } from 'react'
import { BrowserRouter, Route, Switch, withRouter } from 'react-router-dom'

import { requiresAuthentication, noAuthentication } from './AuthInterface'

import Menu from '../containers/Menu' // Menu Screen
import Login from '../containers/Login' // Login Screen
import Closet from '../containers/Closet' // Closet category grid
import ClosetImageGrid from '../containers/Closet/ImageGrid'
import ClosetImageCarousel from '../containers/Closet/ImageCarousel'
import NotFound from '../containers/NotFound'
import ComprasCategory from '../containers/ListCompras/ListComprasCategory'
import ComprasPreview from '../containers/ListCompras/ListComprasPreview'
import PerfilCarousel from '../containers/PerfilCarousel'
import Perfil from '../containers/Perfil'
import Cor from '../containers/Cromatica/Cromatica'
import RememberYou from '../containers/RememberedYou/RememberYou'
import RememberYouCarousel from '../containers/RememberedYou/RememberYouCarousel'
import Sheet from '../containers/Cromatica/Sheet'
import Contrast from '../containers/Cromatica/Contrast'
import ColoringMenuOption from '../containers/Cromatica/ColoringMenuOption'
import ColoringProduct from '../containers/Cromatica/ColoringProduct'
import ColoringSubgroups from '../containers/Cromatica/ColoringSubgroups'
import Agenda from '../containers/Agenda'
import MoodCategory from '../containers/Moodboard/MoodboardCategory'
// import Cart from '../containers/Shop/Cart'
// import Checkout from '../containers/Shop/Checkout'
import PayerInfo from '../containers/Shop/PayerInfo'
import AddCard from '../containers/Shop/AddCard'
// import DeliveryAddress from '../containers/Shop/DeliveryAddress'
// import Orders from '../containers/Shop/Orders'
// import SelectedOrder from '../containers/Shop/SelectedOrder'
// import ShopMenuSelection from '../containers/Shop/ShopMenuSelection'
import Mood from '../containers/Moodboard/Moodboard'
import ResetPassword from '../containers/ResetPassword'
import rp from 'request-promise-native'
import { connect } from 'react-redux'
import * as actions from '../redux/actions'
import ServiceBillingList from '../containers/Shop/ServiceBillingList'
import ServiceBillingCheckout from '../containers/Shop/ServiceBillingCheckout'
import SendResetPasswordEmail from '../containers/SendResetPasswordEmail'
import ComprasVisualization from '../containers/ListCompras/ListComprasVisualization'
import Support from '../containers/Support'

class RenderRoutes extends Component {
  componentDidMount () {
    this.props.setCurrentRoute(this.props.location.pathname)
    this.props.setHistoryPush(this.props.history.push)
  }

  componentDidUpdate (prevProps) {
    this.onRouteChanged(this.props.location.pathname, prevProps.location.pathname)
  }

  onRouteChanged (currentRoute, prevRoute) {
    this.props.setCurrentRoute(currentRoute)
  }

  render () {
    return (
      <Switch>
        <Route path='/login' component={noAuthentication(Login)} />
        <Route path='/esqueci-a-senha' component={noAuthentication(SendResetPasswordEmail)} />
        <Route path='/reset' component={noAuthentication(ResetPassword)} />
        <Route path='/support' component={Support} />
        <Route path='/closet/carousel' component={requiresAuthentication(ClosetImageCarousel)} />
        <Route path='/closet/grid' component={requiresAuthentication(ClosetImageGrid)} />
        <Route path='/closet' component={requiresAuthentication(Closet)} />
        <Route path='/compras/visualizacao' component={requiresAuthentication(ComprasVisualization)} />
        <Route path='/compras/categoria' component={requiresAuthentication(ComprasCategory)} />
        <Route path='/compras' component={requiresAuthentication(ComprasPreview)} />
        <Route path='/perfil' exact component={requiresAuthentication(Perfil)} />
        <Route path='/perfil/carousel' exact component={requiresAuthentication(PerfilCarousel)} />
        {/* <Route path='/cor/looks/categoria' component={requiresAuthentication(LooksCategory)} />
        <Route path='/cor/looks' component={requiresAuthentication(Looks)} /> */}
        <Route path='/cor/cartela' component={requiresAuthentication(Sheet)} />
        <Route path='/cor/contraste' component={requiresAuthentication(Contrast)} />
        <Route path='/cor/:type/categoria/:subgroup' component={requiresAuthentication(ColoringProduct)} />
        <Route path='/cor/:type/categoria' component={requiresAuthentication(ColoringSubgroups)} />
        {/* <Route path='/cor/looks' component={requiresAuthentication(Looks)} /> */}
        <Route path='/rememberyou' exact component={requiresAuthentication(RememberYou)} />
        <Route path='/rememberyou/carousel' exact component={requiresAuthentication(RememberYouCarousel)} />
        <Route path='/cor/:type' component={requiresAuthentication(ColoringMenuOption)} />
        <Route path='/cor' component={requiresAuthentication(Cor)} />
        <Route path='/agenda' component={requiresAuthentication(Agenda)} />
        <Route path='/moodboard/categorias' component={requiresAuthentication(MoodCategory)} />
        <Route path='/moodboard' component={requiresAuthentication(Mood)} />
        {/* <Route path='/finalizar-compra' component={requiresAuthentication(Checkout)} /> */}
        {/* <Route path='/carrinho' component={requiresAuthentication(Cart)} /> */}
        <Route path='/dados-cobranca/cartao/adicionar' component={requiresAuthentication(AddCard)} />
        <Route path='/dados-cobranca' component={requiresAuthentication(PayerInfo)} />
        {/* <Route path='/dados-entrega' component={requiresAuthentication(DeliveryAddress)} /> */}
        {/* <Route path='/minhas-compras/pedidos/:orderId' component={requiresAuthentication(SelectedOrder)} /> */}
        {/* <Route path='/minhas-compras/pedidos' component={requiresAuthentication(Orders)} /> */}
        <Route path='/cobrancas/finalizar-compra' component={requiresAuthentication(ServiceBillingCheckout)} />
        <Route path='/cobrancas' component={requiresAuthentication(ServiceBillingList)} />
        {/* <Route path='/minhas-compras' component={requiresAuthentication(ShopMenuSelection)} /> */}
        <Route path='/' component={requiresAuthentication(Menu)} />
        <Route component={NotFound} />
      </Switch>
    )
  }
}

const RenderRoutesWithRouter = withRouter(RenderRoutes)

class Router extends Component {
  componentWillMount () {
    rp({
      uri: `https://public-api.wordpress.com/rest/v1.1/sites/trendsmosty.wordpress.com/posts/?after=${this.props.dateOfLastReading}`,
      method: 'GET',
      json: true
    })
      .then(data => {
        this.props.setNumberOfNewPosts(data.found)
      })
      .catch(err => console.error(err))
  }

  render () {
    return (
      <BrowserRouter>
        <div style={{ flex: 1, width: '100%', height: '100%' }}>
          <RenderRoutesWithRouter setCurrentRoute={this.props.setCurrentRoute}
            setHistoryPush={this.props.setHistoryPush} />
        </div>
      </BrowserRouter>
    )
  }
}

const mapStateToProps = state => ({
  dateOfLastReading: state.notificationReducer.trends.dateOfLastReading
})

export default connect(mapStateToProps, actions)(Router)



// WEBPACK FOOTER //
// ./src/services/Router.js